import { z } from 'zod';

export type DebugClipboardReadTextCommandArgs = Record<string, never>;

export type DebugClipboardReadTextCommandResult = {
    readonly text: string;
};

export const DebugClipboardReadTextCommandArgsSchema: z.ZodType<DebugClipboardReadTextCommandArgs> =
    z.object({}).strict();

export const DebugClipboardReadTextCommandResultSchema: z.ZodType<DebugClipboardReadTextCommandResult> =
    z.object({ text: z.string() }).strict();
